import { render, staticRenderFns } from "./ReneweDetails.vue?vue&type=template&id=20674407&"
import script from "./ReneweDetails.vue?vue&type=script&lang=js&"
export * from "./ReneweDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports